import React from 'react'
import CountUp from 'react-countup'
import './count.css'

import logo from '../../assets/images/logo.png'
const Count = () => {
  return (
    <div className='count'>
      <div className='container'>
        <div className='weather_lite'>
          <img src={logo} alt='' />
          <a href='#'>
            Weather<span className='active_tag1'>Lite.</span> Data Feed
          </a>
        </div>
        <div className='countup'>
          <div className='row '>
            <div className='col-sm-12 col-md-4 col-lg-4 col-xl-4 border'>
              <p>Countries</p>
              <h2>
                <CountUp end={10531} duration={25} />
              </h2>
            </div>
            <div className='col-sm-12 col-md-4 col-lg-4 col-xl-4 border'>
              <p>Cities</p>
              <h2>
                <CountUp end={50678} duration={25} />
              </h2>
            </div>

            <div className='col-sm-12 col-md-4 col-lg-4 col-xl-4 border'>
              <p>Live Feeds</p>
              <h2>
                <CountUp end={5054} duration={25} />
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Count
